import "./App.css";
import Sidebar from "./components/sidebar";
import Dashboard from "./pages/dashboard";
import React, { useContext } from "react";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import styles from "./app.module.css";
import User from "./pages/user";
import { UserContext } from "./context/userContext";
import LoginPage from "./pages/login";
import Assets from "./pages/assets";
import Withdraw from "./pages/withdraw";
import RankIncome from "./pages/rankIncome";
import RewardBonus from "./pages/rewardBonus";
import SiteMainaintence from "./pages/siteMaintainence";
import Subscription from "./pages/buyPlan";
import MatchingRewards from "./pages/matchingReward";
import Banner from "./pages/banner";
import Rewardreport from "./pages/rewardReport";
import RankReport from "./pages/rankReport";
import MatchingReport from "./pages/matchingRewardReport";
import DepositReport from "./pages/depositReport";
import MissingIncomeReport from "./pages/missingIncomeReport";
import PlanData from "./pages/planData";
import PlanDataCompleted from "./pages/planData/completedPlanData";

function App() {
  const { isAdmin } = useContext(UserContext);
  const token = localStorage.getItem("token");

  const isRestrictedAdmin = token && isAdmin === 2;

  return (
    <React.Suspense fallback={<>Loading...</>}>
      <BrowserRouter>
        {token ? (
          <div className={styles.appContainer}>
            <Sidebar />
            <div className={styles.appRightBox}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  padding: "0% 3% 0 0",
                }}
              >
                <div
                  style={{
                    margin: "1% 0",
                    border: "1px solid #3DACF4",
                    width: "60px",
                    height: "60px",
                    borderRadius: "50%",
                    overflow: "hidden",
                  }}
                >
                  <img
                    src="/icons/commonIcons/Group.png"
                    alt="logo"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                    }}
                  />
                </div>
              </div>
              <Routes>
                {isRestrictedAdmin ? (
                  <>
                    <Route path="/plandata" element={<PlanData />} />
                    <Route
                      path="/plandataCompleted"
                      element={<PlanDataCompleted />}
                    />
                    <Route path="*" element={<PlanData />} />
                  </>
                ) : (
                  <>
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="*" element={<User />} />
                    <Route path="/" element={<login />} />
                    <Route path="/users" element={<User />} />
                    <Route path="/report/assets" element={<Assets />} />
                    <Route path="/login" element={<LoginPage />} />
                    <Route path="/withdraw" element={<Withdraw />} />
                    <Route path="/rank-income" element={<RankIncome />} />
                    <Route path="/reward-bonus" element={<RewardBonus />} />
                    <Route
                      path="/matching-reward"
                      element={<MatchingRewards />}
                    />
                    <Route
                      path="/site-maintenance"
                      element={<SiteMainaintence />}
                    />
                    <Route
                      path="/report/subscription"
                      element={<Subscription />}
                    />
                    <Route path="/banner" element={<Banner />} />
                    <Route path="/report/rewards" element={<Rewardreport />} />
                    <Route
                      path="/report/missingIncomeReport"
                      element={<MissingIncomeReport />}
                    />
                    <Route
                      path="/report/rankIncomeReport"
                      element={<RankReport />}
                    />
                    <Route
                      path="/report/matchingReport"
                      element={<MatchingReport />}
                    />
                    <Route
                      path="/report/depositReport"
                      element={<DepositReport />}
                    />
                  </>
                )}
              </Routes>
            </div>
          </div>
        ) : (
          <Routes>
            <Route path="*" element={<LoginPage />} />
            <Route path="/login" element={<LoginPage />} />
          </Routes>
        )}
      </BrowserRouter>
    </React.Suspense>
  );
}

export default App;
